module.exports = __webpack_public_path__ + "static/btc_code-db1a3c9a2cbd9523080ee413d87b2124.png";